import { compose, withHandlers, withState } from 'recompose';

export const withToggle = compose(
    withState('onToggle', 'toggle', false),
    withHandlers({
        show: ({ toggle }) => e => toggle(true),
        hide: ({ toggle }) => e => toggle(false),
        toggle: ({ toggle }) => e => toggle(currentState => !currentState),
    }),
);



// WEBPACK FOOTER //
// ./src/UI/HOC/withToggle.js